import { useLocation } from 'js/lib/useRouter';

const useIsBrowse = () => {
  const currentRoute = useLocation();
  const wellIsIt = currentRoute?.pathname?.startsWith('/browse');
  return wellIsIt;
};

export default useIsBrowse;
